import { styled } from "styled-components";

import { Spinner } from "common/components";
import { useTranslate } from "common/utilities/useTranslate";

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 1rem 2rem;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  transform: translate3d(-50%, -50%, 0);
  z-index: 1;
`;

const StyledSpinner = styled(Spinner)`
  width: 22px;
  height: 22px;
  margin-right: 0.6rem;
  min-width: 14px;
  color: ${({ theme }) => theme.colors.blue};
`;

const StyledText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.fillPrimary};
  font-size: 1.1rem;
`;

export const LoadingIndicator = () => {
  const translate = useTranslate();
  return (
    <StyledContainer>
      <StyledSpinner />
      <StyledText>{translate("app.loading")}</StyledText>
    </StyledContainer>
  );
};
